<template>
    <div>
        <div style="display:flex">
            <span class="searchtips">安装地址</span>
            <div class="uni_ellipsis invoicedetail">
                <i class="el-icon-edit" @click="changePlace()"></i>
                <span @click="changePlace()">{{contactValue}}</span>
            </div>
        </div>
        <el-dialog :visible.sync="placeDialog" title="更改安装地址" width="60%">
            <place-manage
                ref="placeManage"
                @close="closePlace(arguments)"
            />
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="selectPlace"
                    >确认</el-button
                >
                <el-button type="primary" @click="placeDialog = false"
                    >关闭</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import placeManage from "./list";
export default {
    components: {
        placeManage
    },
    props:{
        contact:{
            type:String|Number,
            default:"",
        },
        cid:{
            type:Number,
            default:0,
        }
    },
    data(){
        return{
            placeDialog: false,
            contactValue:'',
        }
    },
    methods:{
        init:function(callback){
            this.$api.customerWorkAddress({cid:this.cid}).then(res=>{
                if(res.data.code==1){
                    let info = res.data.data;
                    if(info.length>0){
                        let item = info[0];
                        if(callback){
                            callback(item);
                        }
                        this.contactValue = item.district.join("")+item.address;
                    }else{
                        this.contactValue = "暂无收货信息";
                    }
                }
            })
        },
        changePlace() {
            this.placeDialog = true;
            this.$nextTick(() => {
                this.$refs.placeManage.getList(
                    this.cid,
                    this.contact,
                );
            });
        },
        closePlace(value) {
            var place = value[0];
            this.$emit("setContact",place.id);
            this.contactValue = place.district.join("")+place.address;
            this.placeDialog = false;
        },
        selectPlace() {
            this.$nextTick(() => {
                this.$refs.placeManage.checkPlace();
            });
        },
    }
}
</script>
<style scoped>
.invoicedetail{
    width:400px;
    flex-grow:1;
    line-height:40px;
    font-size:14px;
    color: #409EFF;
}
.invoicedetail span{
    cursor: pointer;
    font-size: 12px;
}
.invoicedetail i{
    cursor: pointer;
}
</style>